


// Generated from io.spcfy.orders.samplemeta.enums.LocalityType

export type LocalityTypeKey =
  "URBAN" |
  "SEMI_AGRICULTURAL" |
  "FOREST" |
  "AGRICULTURE" |
  "WETLANDS" |
  "COASTAL_MARINE" |
  "GRASSLANDS" |
  "MOUNTAINOUS" |
  "FRESHWATER";


export interface LocalityTypeDTO {
  key: LocalityTypeKey;
  label: string;    
}


export const LocalityTypes: Record<LocalityTypeKey, LocalityTypeDTO> = {
  URBAN: { key: "URBAN", label: "Urban" },
  SEMI_AGRICULTURAL: { key: "SEMI_AGRICULTURAL", label: "Semi-Agricultural" },
  FOREST: { key: "FOREST", label: "Forest" },
  AGRICULTURE: { key: "AGRICULTURE", label: "Agriculture" },
  WETLANDS: { key: "WETLANDS", label: "Wetlands" },
  COASTAL_MARINE: { key: "COASTAL_MARINE", label: "Coastal/Marine" },
  GRASSLANDS: { key: "GRASSLANDS", label: "Grasslands" },
  MOUNTAINOUS: { key: "MOUNTAINOUS", label: "Mountainous" },
  FRESHWATER: { key: "FRESHWATER", label: "Freshwater" }
};
